module.exports = __webpack_public_path__ + "static/media/basicFreediver-bg.3445752d.jpg";